module.exports = __webpack_public_path__ + "img/calendar-white.86d2b723.svg";